import { format } from 'date-fns'

import { getKoreanCommonGradeSemester } from '~/@entities/SchoolSystem'

import type { PublicWorkbook, Workbook } from './schemas'

type _GradeSemesterSource = Pick<Workbook, 'type' | 'schoolType' | 'grade' | 'semester'>

/**
 * 교재의 학교급·학년·학기(고등은 과목)를 짧게 적는다. 초 3-1, 중1(중학 교과서), 수학Ⅰ.
 * 중학 교과서는 학기 없이 학년 단위로 나온다.
 */
export const formatWorkbookGradeSemester = ({
  type,
  schoolType,
  grade,
  semester,
}: _GradeSemesterSource): string => {
  const { koSchoolType, koSubject } = getKoreanCommonGradeSemester({
    grade,
    // 고등은 학기 대신 과목을 쓰므로 학기 값이 결과에 쓰이지 않는다
    semester: semester ?? 1,
    schoolType,
  })
  if (schoolType === 'MIDDLE' && type === 'SCHOOL') return `${koSchoolType}${grade}`
  if (schoolType === 'HIGH') return koSubject ?? ''
  return `${koSchoolType} ${grade}-${semester}`
}

/** 대제목과 소제목을 화면용으로 잇는다. 소제목이 없으면 대제목만. */
export const formatWorkbookTitle = ({ title, subtitle }: Pick<Workbook, 'title' | 'subtitle'>) =>
  subtitle ? `${title} - ${subtitle}` : title

/** 시중교재의 정답 지원 여부 칸 */
export const formatPublicWorkbookAnswerConfirmed = ({
  answerConfirmed,
}: Pick<PublicWorkbook, 'answerConfirmed'>) => (answerConfirmed ? '지원' : '미지원')

/** 목록의 생성일 칸. yy.MM.dd */
export const formatWorkbookCreateDate = ({ createDatetime }: Pick<Workbook, 'createDatetime'>) =>
  format(new Date(createDatetime), 'yy.MM.dd')
